import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2c8fbd0c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=2c8fbd0c&prod&lang=less"
import style1 from "./App.vue?vue&type=style&index=1&id=2c8fbd0c&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports